import {
    SET_SAVE_ASSET_INVENTORY,
    SET_VALIDATE_ASSET_INVENTORY_RESET
} from "./AssetInventoryResetTypes";

const initialData = {
    isValidForReset: {},
    isAssetInventoryRested: null
}

const reducers = (state = initialData, action: any) => {
    switch (action.type) {
        case SET_VALIDATE_ASSET_INVENTORY_RESET:
            return {
                ...state,
                isValidForReset: action.isValidForReset,
            };
        case SET_SAVE_ASSET_INVENTORY:
            return {
                ...state,
                isAssetInventoryRested: action.isAssetInventoryRested,
            };
        default:
            return state;
    }
}

export default reducers